import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ConfigProvider, Layout, Button, Dropdown } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { Apps, Versions, VersionFiles, Login } from './pages';
import 'antd/dist/reset.css';

const { Header, Content } = Layout;

// 受保护的路由组件
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem('token');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

function App() {
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem('token'));
  const currentPath = window.location.pathname;

  useEffect(() => {
    setLoggedIn(!!localStorage.getItem('token'));
  }, [currentPath]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_info');
    setLoggedIn(false);
    window.location.href = '/login';
  };

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  const userInfo = localStorage.getItem('user_info');
  let user = null;
  if (userInfo) {
    try {
      user = JSON.parse(userInfo);
    } catch (e) {
      // ignore
    }
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <Router>
        <Routes>
          {/* 登录页面 */}
          <Route path="/login" element={<Login />} />

          {/* 受保护的主应用 */}
          <Route
            path="/*"
            element={
              <>
                <Layout style={{ minHeight: '100vh' }}>
                  <Header style={{ display: 'flex', alignItems: 'center', padding: '0 24px' }}>
                    <div
                      style={{ display: 'flex', alignItems: 'center', marginRight: 'auto', cursor: 'pointer' }}
                      onClick={() => window.location.href = '/apps'}
                    >
                      <img src="/logo.svg" alt="Logo" style={{ height: 32, marginRight: 12 }} />
                      <span style={{ color: 'white', fontSize: 20, fontWeight: 'bold' }}>
                        琉璃月更新系统
                      </span>
                    </div>
                    {loggedIn && (
                      <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                        <Button type="link" style={{ color: 'white' }}>
                          <UserOutlined style={{ marginRight: 8 }} />
                          {user?.username || user?.email || '用户'}
                        </Button>
                      </Dropdown>
                    )}
                  </Header>
                  <Content style={{ padding: '24px 50px', background: '#f0f2f5' }}>
                    <Routes>
                      <Route path="/" element={<Navigate to="/apps" replace />} />
                      <Route
                        path="/apps"
                        element={
                          <ProtectedRoute>
                            <Apps />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/apps/:appId/versions"
                        element={
                          <ProtectedRoute>
                            <Versions />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/versions/:versionId/files"
                        element={
                          <ProtectedRoute>
                            <VersionFiles />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </Content>
                </Layout>
              </>
            }
          />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
